import { useRef } from 'react';

export default function useScroll<T extends HTMLElement>() {
  const ref = useRef<T | null>(null);

  function up() {
    if (ref.current) {
      ref.current.scroll({
        top: 0,
        behavior: 'smooth',
      });
    }
  }

  function down() {
    if (ref.current) {
      ref.current.scroll({
        top: ref.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  }

  return { ref, up, down };
}
